<template>
  <div class="content background1" style="width: 100%;display: flex">
    <div class="tableBox9" v-if="!qrCodeShow">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane :label="$t('label_429')" name="first">
              <tree :dataTree="treeData" @getDeviceMes="getDeviceMes" :treeType="0"></tree>
            </el-tab-pane>
            <el-tab-pane :label="this.$t('label_161')" name="second">
              <tree :dataTree="treeData2" @getDeviceMes="getDeviceMes" :treeType="1"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="right-showbtn" @click="showBtn">
      <div class="right-showbtn-qrcode-background">
        <i v-if="qrCodeShow" class="el-icon-arrow-right"
           style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
        <i v-if="!qrCodeShow" class="el-icon-arrow-left"
           style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
      </div>
    </div>
    <div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{ deviceDetailMes.name }}</span>{{ $t('label_590') }}</p>
            <div class="chooseBox spaceBetween" style="height: 100px;width: 100%; float: left;">
              <div class="selectBox">
                <div>
                  <div class="selectChoose" style="width:240px">
                    <div class="selectText">
                      <p>{{ $t('label_593') }}</p>
                    </div>
                    <div class="select" style="width: 220px;">
                      <el-input v-model="code" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" style="width:240px">
                    <div class="selectText">
                      <p>{{ $t('label_483') }}</p>
                    </div>
                    <div class="select" style="width: 200px;">
                      <el-input v-model="maintainName" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div style="width: 580px">
                  <div class="selectChoose" style="width: 100%;">
                    <div class="selectText" style="width: 88px;">
                      <p>{{ $t('label_596') }}</p>
                    </div>
                    <div class="select timeRadio" style="width: 292px">
                      <el-radio-group v-model="checkTime" @change="checkTimebtn">
                        <el-radio-button label="0">{{ $t('label_599') }}</el-radio-button>
                        <el-radio-button label="1">{{ $t('label_743') }}</el-radio-button>
                        <el-radio-button label="2">{{ $t('label_542') }}</el-radio-button>
                        <el-radio-button label="3">{{ $t('label_540') }}</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="select" style="width: 330px">
                      <el-date-picker v-if="checkTime==0" v-model="Readytime" :editable="false" :clearable="false"
                                      format="yyyy-MM-dd"
                                      value-format="yyyy-MM-dd" type="daterange" :range-separator="$t('label_264')"
                                      :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')"
                                      key="daterange">
                      </el-date-picker>
                      <el-date-picker v-if="checkTime==1" v-model="Readytime1" :editable="false" :clearable="false"
                                      format="yyyy-MM-dd"
                                      value-format="yyyy-MM-dd" type="week" @change="changeTime"
                                      :picker-options="{ firstDayOfWeek: 1}">
                      </el-date-picker>
                      <el-date-picker v-if="checkTime==2" v-model="Readytime1" :editable="false" :clearable="false"
                                      format="yyyy-MM"
                                      value-format="yyyy-MM-dd" type="month" @change="changeTime">
                      </el-date-picker>
                      <el-date-picker v-if="checkTime==3" v-model="Readytime1" :editable="false" :clearable="false"
                                      format="yyyy"
                                      value-format="yyyy-MM-dd" type="year" @change="changeTime">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox" style="width: 150px;">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i
                    class="el-icon-search"></i>{{ $t('btn_2') }}
                  </div>
                </div>
              </div>
              <div class="selectBox">
                <div>
                  <div class="selectChoose" style="width: 300px">
                    <div class="selectText">
                      <p>{{ $t('label_602') }}</p>
                    </div>
                    <div class="select" style="width:220px">
                      <el-select v-model="checkStatus" :disabled="checkFlag" clearable>
                        <el-option v-for="item in checkStatusOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" style="width: 340px">
                    <div class="select" style="width:310px; margin: auto;">
                      <el-switch v-model="switched" active-color="#13ce66" inactive-color="#409eff"
                                 :active-text="$t('label_933')"
                                 :inactive-text="$t('label_934')" style="height: 40px;">
                      </el-switch>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="spotStatusNumList">
              <div class="statusMesBox" v-for="(item,index) in spotStatusNumList"
                   :class="item.check==true?'check':''">
                <div class="iconBox" :class="item.icon"></div>
                <div class="textBox">
                  <p>{{ item.text }}</p>
                  <p class="num" :style="{'color':item.color}">{{ item.num }}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="item.check" @change="spotStatusNumChange"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" style="height: calc(100% - 270px)">
              <div class="buttonBox" style="margin-left: -4px;">
                <div>
                  <div class="chooseButton searchButton" @click="results" v-if="MenuRoleList.indexOf('120')>=0">
                    {{ $t('btn_28') }}
                  </div>
                  <!-- <div class="chooseButton searchButton" @click="dialogSpotResult=true"><i class="el-icon-printer"></i>打印</div> -->
                  <div class="chooseButton searchButton" style="width: 100px;" @click="saveRemark()"
                       v-if="MenuRoleList.indexOf('187')>=0">{{ $t('btn_29') }}
                  </div>
                  <!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('121')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
                </div>

<!--                <div v-if="MenuRoleList.indexOf('184')>=0" style="margin-left: 4px;">-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;"-->
<!--                       @click="checkBack(2)">{{ $t('btn_62') }}-->
<!--                  </div>-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="check(1)">-->
<!--                    {{ $t('btn_31') }}-->
<!--                  </div>-->

<!--                </div>-->
<!--                <div v-if="MenuRoleList.indexOf('185')>=0" style="margin-left: 4px;">-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;"-->
<!--                       @click="checkBack(1)">{{ $t('btn_61') }}-->
<!--                  </div>-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="check(2)">-->
<!--                    {{ $t('btn_32') }}-->
<!--                  </div>-->

<!--                </div>-->
<!--                <div v-if="MenuRoleList.indexOf('186')>=0" style="margin-left: 4px;">-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;"-->
<!--                       @click="checkBack(3)">{{ $t('btn_63') }}-->
<!--                  </div>-->
<!--                  <div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="check(3)">-->
<!--                    {{ $t('btn_33') }}-->
<!--                  </div>-->

<!--                </div>-->
                <div v-if="checkFlag">
                  <div class="chooseButton searchButton" style="width: 100px;" @click="checkOff">{{ $t('btn_35') }}
                  </div>
                  <div class="chooseButton searchButton" style="width: 100px;" @click="checkOne">
                    {{ $t('label_158') }}
                  </div>
                  <div class="chooseButton searchButton" style="width: 100px;" v-if="tableDataTreeTime.length>0" @click="checkAll">{{ $t('btn_34') }}
                  </div>
                </div>


              </div>
              <div class="tableMin" style="height: calc(100% - 50px)">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime"
                          highlight-current-row @current-change="handleCurrentChangeTreeTime"
                          border style="width: 100%;margin: 10px 0"
                          :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
                          height="90%" @row-click="handler">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                                   :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_593')" align="center" width="200">
                    <template slot-scope="scope">
                      <p class="tableMiTitle">
                        {{ scope.row.superior }}<br>
                        {{ scope.row.fname }} {{ scope.row.name }}<br>
                        {{ scope.row.code }}<br>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="maintainName" :label="$t('label_483')" align="center">
                  </el-table-column>
                  <el-table-column prop="maintainUserName" :label="$t('label_635')" align="center">
                  </el-table-column>
                  <el-table-column prop="beginTime" :label="$t('label_643')" align="center">
                    <template slot-scope="scope">
                      <p>{{ scope.row.beginTime.split(' ')[0] }}</p>
                      <p>{{ scope.row.endTime.split(' ')[0] }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="maintainBeginTime" :label="$t('label_639')" align="center">
                    <template slot-scope="scope">
                      <p v-if="scope.row.maintainBeginTime==null">--</p>
                      <p v-if="scope.row.maintainBeginTime!=null">{{ scope.row.maintainBeginTime.split(' ')[0] }}</p>
                      <p v-if="scope.row.maintainEndTime!=null">{{ scope.row.maintainEndTime.split(' ')[0] }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" :label="$t('label_13')" align="center">
                    <template slot-scope="scope">
                      <p :style="{'color':spotStatusNumList[scope.row.status].color}">
                        {{ spotStatusNumList[scope.row.status].text }}</p>
                    </template>
                  </el-table-column>
<!--                  <el-table-column prop="checkStatus" :label="$t('btn_31') + $t('label_412')" align="center"-->
<!--                                   width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                      <p :style="{'color':scope.row.checkStatus>1?'#0353c1':'#ffb400'}">-->
<!--                        {{ scope.row.checkStatus > 1 ? $t('label_258') : $t('label_254') }}</p>-->
<!--                      <p v-if="scope.row.checkStatus>1">{{ scope.row.monitorUser }}</p>-->
<!--                      <p v-if="scope.row.monitorTime!=null">{{ scope.row.monitorTime.split(' ')[0] }}</p>-->
<!--                      <p v-if="scope.row.monitorTime!=null">{{ scope.row.monitorTime.split(' ')[1] }}</p>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column prop="checkStatus" :label="$t('btn_32') + $t('label_412')" align="center"-->
<!--                                   width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                      <p :style="{'color':scope.row.checkStatus>2?'#0353c1':'#ffb400'}">-->
<!--                        {{ scope.row.checkStatus > 2 ? $t('label_258') : $t('label_254') }}</p>-->
<!--                      <p v-if="scope.row.checkStatus>2">{{ scope.row.supervisorUser }}</p>-->
<!--                      <p v-if="scope.row.supervisorTime!=null">{{ scope.row.supervisorTime.split(' ')[0] }}</p>-->
<!--                      <p v-if="scope.row.supervisorTime!=null">{{ scope.row.supervisorTime.split(' ')[1] }}</p>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column prop="checkStatus" :label="$t('btn_33') + $t('label_412')" align="center"-->
<!--                                   width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                      <p :style="{'color':scope.row.checkStatus==4?'#0353c1':'#ffb400'}">-->
<!--                        {{ scope.row.checkStatus == 4 ? $t('label_258') : $t('label_254') }}</p>-->
<!--                      <p v-if="scope.row.checkStatus==4">{{ scope.row.sectionChiefUser }}</p>-->
<!--                      <p v-if="scope.row.sectionChiefTime!=null">{{ scope.row.sectionChiefTime.split(' ')[0] }}</p>-->
<!--                      <p v-if="scope.row.sectionChiefTime!=null">{{ scope.row.sectionChiefTime.split(' ')[1] }}</p>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column prop="remark" :label="$t('btn_29')" align="center"></el-table-column>
                </el-table>
                <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
                      :currentspage="1"
                      @parentMethod="search" v-show="!checkFlag"></Page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('btn_28')" :visible.sync="dialogSpotResult" append-to-body :close-on-click-modal='false'
               width="1100px"
               top="3%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="titleMes">
          <p>{{ deptName }}<br>{{ typeName }}</p>
          <p>{{ $t('label_635') }}：{{ tableDataTreeInfo.maintainUserName }}</p>
        </div>
        <div class="proSpotMes">
          <div class="proMes">
            <div class="proP">
              <p v-bind:style="styleObject4">
                {{
                  tableDataTreeInfo.maintainBeginTime == null ? '' : tableDataTreeInfo.maintainBeginTime.substring(0, 19)
                }}</p>
              <p v-bind:style="styleObject5">
                {{
                  tableDataTreeInfo.maintainEndTime == null ? '' : tableDataTreeInfo.maintainEndTime.substring(0, 19)
                }}</p>
            </div>
            <div class="proTime">
              <p v-bind:style="styleObject1"></p>
              <p v-bind:style="styleObject2"></p>
              <p v-bind:style="styleObject3"></p>
            </div>
            <div class="proUp">
              <p v-bind:style="styleObject6">
                {{ tableDataTreeInfo.beginTime == null ? '' : tableDataTreeInfo.beginTime.substring(0, 19) }}</p>
              <p v-bind:style="styleObject7">
                {{ tableDataTreeInfo.endTime == null ? '' : tableDataTreeInfo.endTime.substring(0, 19) }}</p>
            </div>
          </div>
          <div class="proText">
            <p>{{ $t('label_639') }} <span class="real">{{ tableDataTreeInfo.time1 }}</span>分<span
              class="real">{{ tableDataTreeInfo.time2 }}</span>{{ $t('label_649') }}</p>
            <p><i class="cricleIcon" style="background: #3fb393"></i>{{ $t('label_580') }}
              {{
                tableDataTreeInfo.maintainBeginTime == null ? '' : tableDataTreeInfo.maintainBeginTime.substring(0, 19)
              }}
            </p>
            <p><i class="cricleIcon" style="background: #3fb393"></i>{{ $t('label_585') }}
              {{
                tableDataTreeInfo.maintainEndTime == null ? '' : tableDataTreeInfo.maintainEndTime.substring(0, 19)
              }}
            </p>
            <p>{{ $t('label_643') }} <span class="plan">{{ tableDataTreeInfo.time3 }}</span>分<span
              class="plan">{{ tableDataTreeInfo.time4 }}</span>{{ $t('label_649') }}</p>
            <p><i class="cricleIcon" style="background: #0353c1"></i>{{ $t('label_580') }}
              {{ tableDataTreeInfo.beginTime == null ? '' : tableDataTreeInfo.beginTime.substring(0, 19) }}</p>
            <p><i class="cricleIcon" style="background: #0353c1"></i>{{ $t('label_585') }}
              {{ tableDataTreeInfo.endTime == null ? '' : tableDataTreeInfo.endTime.substring(0, 19) }}</p>
          </div>
        </div>
        <div class="treeMes" style="padding: 0px;">
          <div class="spotMesBox">
            <el-tabs v-model="mainEditTree" type="card" @tab-click="handleClick0">
              <el-tab-pane :label="$t('label_483')" name="project">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTree" highlight-current-row
                          @current-change="handleCurrentChangeTree"
                          border style="width: 100%;" height="300px"
                          :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                                   :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_483')" align="left" width="220">
                    <template slot-scope="scope">
                      {{ scope.row.name }}
                      <br>
                      {{ scope.row.content }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="spotCycle" :label="$t('label_509')" align="center">
                    <template slot-scope="scope">
                      <p v-if="scope.row.cycleType==1 && scope.row.cycle==1 ">{{ $t('label_652') }}</p>
                      <p v-if="scope.row.cycleType==1 && scope.row.cycle!=1 ">
                        {{ $t('label_531') }}{{ scope.row.cycle }}{{ $t('label_537') }}</p>
                      <p v-if="scope.row.cycleType==2 ">{{ weekendMesOptions[scope.row.cycle] }}</p>
                      <p v-if="scope.row.cycleType==3 ">
                        {{ $t('label_654') }}{{ scope.row.cycle }}{{ $t('label_537') }}</p>
                      <template v-if="scope.row.cycleType=='4'">
                        {{ $t('label_531') }}{{ "" + scope.row.cycle + "" }}{{ $t('label_534') }}
                      </template>
                      <template v-if="scope.row.cycleType=='5'">
                        {{ $t('label_935') }}{{ "" + scope.row.cycle.split(',')[0] }}{{
                          $t('label_540')
                        }}{{ scope.row.cycle.split(',')[1] }}{{ $t('label_542') }}{{
                          scope.row.cycle.split(',')[2]
                        }}{{ $t('label_537') }}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="maintainResult" :label="$t('btn_28')" align="center">
                    <template slot-scope="scope">
                      <p v-if="scope.row.maintainResult=='0'" style="color: #FF0000;">{{ $t('label_657') }}</p>
                      <p v-if="scope.row.maintainResult=='1'">{{ $t('label_322') }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="photo" :label="$t('label_660')" align="center" width="200px">
                    <template slot-scope="scope">
											<span
                        v-for="item in  ((scope.row.photo==null||scope.row.photo=='')?[]:scope.row.photo.split(','))"
                        style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px">
												<img style="width: 30px;height: 30px;"
                             :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                             @click="show(item,'photo')">
											</span>
                      <!-- <span v-for="item in (scope.row.video==null?[]:scope.row.video.split(','))" style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px">
                        <img style="width: 30px;height: 30px;" src="../../assets/img/spot/video.png" @click="show(item,'video')">
                      </span> -->
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane :label="$t('label_662')" name="bei">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataBeijian"
                          highlight-current-row @current-change="handleCurrentChangeTree"
                          border style="width: 100%;" height="300px"
                          :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                                   :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('label_664')" align="center">
                  </el-table-column>
                  <el-table-column prop="model" :label="$t('label_666')" align="center">
                  </el-table-column>
                  <el-table-column prop="useNum" :label="$t('label_668')" align="center">
                  </el-table-column>
                  <el-table-column prop="price" :label="$t('label_670')" align="center">
                  </el-table-column>
                  <el-table-column prop="maker" :label="$t('label_672')" align="center">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <!-- <el-tab-pane label="风险确认" name="feng" style="height: 260px">
                <div class="confirmTitle">
                  <p v-for="(item,index) in fengXianConfrim" @click="selectProp(index)" :class="select == index ? 'active':''">{{item.val}}</p>
                </div>
                <div class="confirmMess cb">
                  <p class="title"><span>{{fengXianConfrim[select].val}}</span>风险安全措施确认内容</p>
                  <div class="content">
                    <el-checkbox-group v-model="checkComfrim">
                      <p v-for="item2 in fengXianConfrim[select].check">
                        <el-checkbox disabled :label="item2.mes"></el-checkbox>
                      </p>
                    </el-checkbox-group>
                  </div>
                </div>
              </el-tab-pane> -->

              <el-tab-pane :label="$t('label_600')" name="fengx4" class="fxqrjl">
                <div class="tabBbox" style="height: 100%" v-if="tableDataInfo&&tableDataInfo.appointMeet == 1">
                  <div class="buttonBox" style="width: 100%; margin-bottom: 10px;">
                    <div class="chooseButton searchButton" @click="riskExcel">{{ $t('btn_51') }}</div>
                    <div class="block" style="margin-left: 20px;">
                      <el-date-picker v-model="fengxianlihuiTime1" type="datetime" :placeholder="$t('input_89')"
                                      value-format="yyyy-MM-dd HH:mm:ss"
                                      format="yyyy-MM-dd HH:mm:ss" @change="fengTime">
                      </el-date-picker>
                      -
                      <el-date-picker v-model="fengxianlihuiTime2" type="datetime" :placeholder="$t('input_89')"
                                      value-format="yyyy-MM-dd HH:mm:ss"
                                      format="yyyy-MM-dd HH:mm:ss" @change="fengTime">
                      </el-date-picker>
                    </div>
                  </div>
                  <div style="margin-top: 10px;">
                    <span style="font-size: 16px;">1、{{ $t('label_605') }}</span>
                    <span style="font-size: 12px;font-weight: bold;"></span>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data1" highlight-current-row
                            :span-method="objectSpanMethod1" border
                            style="width: 100%;margin: 10px 0"
                            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex1"
                                     width="50">
                    </el-table-column>
                    <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left"
                                     width="400">
                    </el-table-column>
                    <el-table-column v-for="(day,index) in feng4Date1" :key="index" :label="getLable1(index)"
                                     align="center"
                                     :width="150">
                      <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', '日')" width="120"
                                       align="center">
                        <template slot-scope="scope">
                          <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                            <span v-if="name.length<50">{{ name == '1' ? '✔' : name == '0' ? '✖' : name }}</span>
                            <span v-if="name.length>50">
															<img :src="(index==0?'':'data:image/')+name"
                                   style="transform: rotate(270deg); width: 60px;height: 60px;"
                                   @click="showImg((index==0?'':'data:image/')+name)"/>
														</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                  <div style="margin-top: 10px;">
                    <span style="font-size: 16px;">2、{{ $t('label_683') }}</span>
                    <span style="font-size: 12px;font-weight: bold;">{{ $t('label_685') }}</span>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data2" highlight-current-row
                            :span-method="objectSpanMethod2" border
                            style="width: 100%;margin: 10px 0"
                            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex2"
                                     width="50">
                    </el-table-column>
                    <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left"
                                     width="400">
                    </el-table-column>
                    <el-table-column v-for="(day,index) in feng4Date2" :key="index" :label="getLable1(index)"
                                     align="center"
                                     :width="150">
                      <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', '日')" width="120"
                                       align="center">
                        <template slot-scope="scope">
                          <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                            <span v-if="name.length<50">{{ name == '1' ? '✔' : name == '0' ? '✖' : name }}</span>
                            <span v-if="name.length>50">
															<img :src="(index==0?'':'data:image/')+name"
                                   style="transform: rotate(270deg); width: 60px;height: 60px;"
                                   @click="showImg((index==0?'':'data:image/')+name)"/>
														</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                  <div style="margin-top: 10px;">
                    <span style="font-size: 16px;">3、{{ $t('label_688') }}</span>
                    <span style="font-size: 12px;font-weight: bold;">{{ $t('msg_69') }}</span>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data3" highlight-current-row
                            :span-method="objectSpanMethod3" border
                            style="width: 100%;margin: 10px 0"
                            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex3"
                                     width="50">
                    </el-table-column>
                    <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left"
                                     width="400">
                    </el-table-column>
                    <el-table-column v-for="(day,index) in feng4Date3" :key="index" :label="getLable1(index)"
                                     align="center"
                                     :width="150">
                      <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', '日')" width="120"
                                       align="center">
                        <template slot-scope="scope">
                          <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                            <span v-if="name.length<50">{{ name == '1' ? '✔' : name == '0' ? '✖' : name }}</span>
                            <span v-if="name.length>50">
															<img :src="(index==0?'':'data:image/')+name"
                                   style="transform: rotate(270deg); width: 60px;height: 60px;"
                                   @click="showImg((index==0?'':'data:image/')+name)"/>
														</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                  <div style="margin-top: 10px;">
                    <span style="font-size: 16px;">4、{{ $t('label_693') }}</span>
                    <span style="font-size: 12px;font-weight: bold;"></span>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data4" highlight-current-row
                            :span-method="objectSpanMethod4" border
                            style="width: 100%;margin: 10px 0"
                            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex4"
                                     width="50">
                    </el-table-column>
                    <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left"
                                     width="400">
                    </el-table-column>
                    <el-table-column v-for="(day,index) in feng4Date4" :key="index" :label="getLable1(index)"
                                     align="center"
                                     :width="150">
                      <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', '日')" width="120"
                                       align="center">
                        <template slot-scope="scope">
                          <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                            <span v-if="name.length<50">{{ name == '1' ? '✔' : name == '0' ? '✖' : name }}</span>
                            <span v-if="name.length>50">
															<img :src="(index==0?'':'data:image/')+name"
                                   style="transform: rotate(270deg); width: 60px;height: 60px;"
                                   @click="showImg((index==0?'':'data:image/')+name)"/>
														</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="tabBbox" style="height: 100%" v-else>
                  <div class="buttonBox" style="width: 100%; margin-bottom: 10px;">
                    <div class="chooseButton searchButton" @click="riskExcel">{{ $t('btn_51') }}</div>
                  </div>
                  <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data" highlight-current-row
                            :span-method="objectSpanMethod" border
                            style="width: 100%;" height="300px"
                            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                    <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                                     :index="getIndex0" width="50">
                    </el-table-column>
                    <el-table-column prop="item" :label="$t('label_695')" header-align="center" align="left"
                                     width="400">
                    </el-table-column>
                    <el-table-column v-for="(day,index) in feng4Date" :key="index" :label="getLable(index)"
                                     align="center">
                      <el-table-column :prop="day" :label="day.substring(0,16)" width="120" align="center">
                        <template slot-scope="scope">
                          <p v-for="(names,index) in scope.row[day].split(',data:image/')">
                            <span v-if="names.length<50">{{ names == '1' ? '✔' : names == '0' ? '✖' : names }}</span>
                            <span v-if="names.length>50">
															<img :src="(index==0?'':'data:image/')+names"
                                   style="transform: rotate(270deg); width: 60px;height: 60px;"
                                   @click="showImg((index==0?'':'data:image/')+names)"/>
														</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="tableMes2">
              <div class="box"
                   style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                           :file-list="fileList"
                           :http-request="upload" :show-file-list="false">
                  <i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
                </el-upload>
              </div>
              <div v-for="(item,index) in fileId" class="photoNewdiv">
                <img v-if="showIcon(item)" class="imgstyle"
                     :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                     @click="previewPdf(item)">
                <img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png"
                     @click="previewPdf(item)">
                <i class="el-icon-close imgdelect" @click="removeFaultImg(index)"></i>
                <el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
                  <span class="fileName">{{ showName(item) }}</span>
                </el-tooltip>
              </div>

            </div>
            <!--						<div class="buttonBox" style="width: 100px; margin:10px auto;">-->
            <!-- <div class="chooseButton searchButton" @click="riskExcel">风险确认单</div> -->
            <!--							<div class="chooseButton searchButton" @click="listExcel"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
            <!--						</div>-->

          </div>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog title="图片" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
     top="10%" :before-close="closeImg" custom-class="dialogBox" >
      <div class="dialogBoxMes" style="padding:0 20px;">
        <img style="width: 100%;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
      </div>
    </el-dialog> -->
    <!-- <el-dialog title="视频" :visible.sync="dialogVideo" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
     top="10%" :before-close="closeImg" custom-class="dialogBox" >
      <div class="dialogBoxMes" style="padding:20px 20px;">
        <video width="100%" height="500" controls autoplay="autoplay">
          <source :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
        </video>
      </div>
    </el-dialog> -->
    <el-dialog :visible="showPicture || showPdf" :show-close="true" :width="'80%'" append-to-body
               class="dialog-div-pre-style"
               :before-close="closePreviewClick" center>
      <div v-if="showPicture" class="dialog-body-content-base-style">
        <img style="width: 100%;height: 600px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
      </div>
      <div v-if="showPdf" class="dialog-body-content-base-style">
        <iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%'
                height="600px">
        </iframe>
      </div>
      <span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="downFile">{{ $t('btn_12') }}</div>
			</span>
    </el-dialog>
    <el-dialog :title="$t('label_696')" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false'
               width="800px"
               :before-close="handleCloseImg" custom-class="dialogBox">
      <img :src="imgUrl" style="transform: rotate(270deg); width: 380px;height:600px; margin-left: 200px;"/>
    </el-dialog>
    <el-dialog :title="$t('label_251')" :visible.sync="dialogImg2" append-to-body :close-on-click-modal='false'
               width="800px"
               :before-close="handleCloseImg2" custom-class="dialogBox">
      <img :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" style=" width: 100%;height:600px;"/>
    </el-dialog>
    <el-dialog v-loading="saveLoading" :title="$t('btn_29')" :visible.sync="dialogSpotRemark" append-to-body
               :close-on-click-modal='false'
               width="400px" top="20%"
               :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogMes">
        <p>{{ $t('btn_29') }}</p>
        <div class="mesInput">
          <el-input v-model="newType.remark"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="newTypeSave">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>
    <exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList"
               ref="exportBox"></exportMes>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import utils from '@/utils/utils'
import tree from "@/components/list/tree/maintainTree";
import maintenance from "@/assets/js/maintenance/maintenance.js";
import exportMes from "@/components/list/export/export";
import file from "@/assets/js/file/file.js";

export default {
  name: 'spotResumePage',
  components: {
    Page,
    tree,
    exportMes,
  },
  data() {
    return {
      saveLoading: false,
      fileList: [],
      switched: true,
      pickerOptions1: {
        disabledDate(date) {
          let now = new Date();
          let nowTime = now.getTime();
          let day = now.getDay() == 0 ? 7 : now.getDay();
          let oneDayTime = 24 * 60 * 60 * 1000;
          // 上周日时间戳
          let MondayTime = nowTime - day * oneDayTime;
          return date.getTime() > new Date(MondayTime);
        }
      },
      pickerOptions2: {
        disabledDate(date) {
          let now = new Date();
          return date.getTime() > now.setMonth(now.getMonth() - 1);
        }
      },
      pickerOptions3: {
        disabledDate(date) {
          let now = new Date();
          return date.getTime() > now.setFullYear(now.getFullYear() - 1);
        }
      },
      checkFlag: false,
      checkUser: 0,
      pageNum: 1,
      select: 0,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      Readytime1: '',
      Readytime1_: '',
      Readytime2: '',
      Readytime3: '',
      checkStatus: 0,
      checkTime: 0,
      checkStatusOptions: [{
        label: this.$t('label_272'),
        value: 0
      }, {
        label: this.$t('label_700'),
        value: 1
      }, {
        label: this.$t('label_702'),
        value: 2
      }, {
        label: this.$t('label_704'),
        value: 3
      }, {
        label: this.$t('label_706'),
        value: 4
      }],
      tableDataInfo: {},
      height: 500,
      getTreeMes: '1',
      checkComfrim: ['断开控制柜柜内直流电源开关', '断开控制柜柜内交流电源开关', '绝缘手套佩戴完毕'],
      weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
      checked: false,
      dialogSpotRemark: false,
      dialogSpotResult: false,
      dialogSpotTimeEdit: false,
      dialogSpotBatchTimeEdit: false,
      dialogImg: false,
      dialogVideo: false,
      fengXianConfrim: [],
      MenuRoleList: [],
      newType: {
        id: '',
        remark: ''
      },
      spotStatusNumList: [{
        icon: 'shangwei',
        text: this.$t('label_611'),
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        icon: 'jinxing',
        text: this.$t('label_615'),
        check: true,
        num: '0',
        color: '#3fb393'
      }, {
        icon: 'zhengchang',
        text: this.$t('label_619'),
        check: true,
        num: '0',
        color: '#8a00ff'
      }, {
        icon: 'yuqiwei',
        text: this.$t('label_623'),
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        icon: 'yuqi',
        text: this.$t('label_627'),
        check: true,
        num: '0',
        color: '#ffb400'
      },],
      tableDataBeijian: [{
        name: '齿轮箱油 ',
        type: 'ArNo 6120-10',
        num: '2.8',
        unit: 'L',
        produce: '大连久鹏'
      }, {
        name: '齿轮箱油 ',
        type: 'ArNo 6120-10',
        num: '2.8',
        unit: 'L',
        produce: '大连久鹏'
      }, {
        name: '齿轮箱油 ',
        type: 'ArNo 6120-10',
        num: '2.8',
        unit: 'L',
        produce: '大连久鹏'
      },],
      tableDataTree: [],
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '3'
      },
      tableDataTreeTime: [],
      activeNameTree: 'second',
      activeNameSpot: 'spot',
      mainEditTree: 'project',
      deviceDetailMes: {},
      tableDataTreeInfo: [],
      typeName: '',
      deptName: '',
      status: '',
      id: '',
      maintainName: '',
      styleObject1: {
        width: '0%'
      },
      styleObject2: {
        width: '100%',
        background: '#3fb393'
      },
      styleObject3: {
        width: '0%'
      },
      styleObject4: {
        'width': '0%',
        'text-align': 'right',
        'margin-right': '10px',
        'padding-left': '0%',
        'min-width': '170px'
      },
      styleObject5: {
        'padding-right': '0%',
        'min-width': '170px'
      },
      styleObject6: {
        // 'width': '0%',
        // 'text-align': 'right',
        // 'margin-right': '10px',
        // 'padding-right': '0%',
        // 'min-width': '170px'
		'padding-right': '0%',
		'min-width': '170px'
      },
      styleObject7: {
        'padding-right': '0%',
        'min-width': '170px'
      },
      img: '',
      code: '',
      fileId: [],
      tableDataTreeTimeExport: [],
      exportTitle: this.$t('label_590'),
      exportList: [{
        column: 'superior',
        title: this.$t('label_732'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'fname',
        title: this.$t('label_429'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'name',
        title: this.$t('label_1'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'maintainName',
        title: this.$t('label_483'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'maintainUserName',
        title: this.$t('label_635'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'beginTime',
        title: this.$t('label_643'),
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      },
        {
          column: 'maintainBeginTime',
          title: this.$t('label_5'),
          headerAlign: 'center',
          align: 'center',
          width: '200px'
        },
        {
          column: 'maintainEndTime',
          title: this.$t('label_9'),
          headerAlign: 'center',
          align: 'center',
          width: '200px'
        },
        {
          column: 'status',
          title: this.$t('label_13'),
          headerAlign: 'center',
          align: 'center',
          width: '200px'
        },
      ],
      dialogImg2: false,
      feng4Data: [],
      feng4Date: [],
      feng4Date1: [],
      feng4Data1: [],
      feng4Date2: [],
      feng4Data2: [],
      feng4Date3: [],
      feng4Data3: [],
      feng4Date4: [],
      feng4Data4: [],
      imgUrl: '',
      showIconList: {},
      showPdf: false,
      pdfUrl: '',
      showPicture: false,
      pictureUrl: '',
      showNameList: [],
      fengxianlihuiTime1: '',
      fengxianlihuiTime2: '',
      width: '340px',
      qrCodeShow: false,
    }
  },
  methods: {
    downFile() {
      if (this.showPdf) {
        window.location.href = this.$store.getters.getPostUrl + 'mes/sysFile/download/' + this.pdfUrl;
      }
      if (this.showPicture) {
        window.location.href = this.$store.getters.getPostUrl + 'mes/sysFile/download/' + this.pictureUrl;
      }
    },
    closePreviewClick() {
      this.showPicture = false
      this.showPdf = false
    },
    previewPdf(row) {
      file.selectFileType(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          let type = data.data;
          if (type.indexOf(".pdf") != -1) {
            this.pdfUrl = row;
            this.showPdf = true
          } else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1 || type.indexOf(
            ".gif") != -1) {
            this.pictureUrl = row;
            this.showPicture = true
          } else {
            this.$message(this.$t('msg_9'))
            window.location.href = this.$store.getters.getPostUrl + 'mes/sysFile/download/' + row;
          }
        } else {
          this.$message(this.$t('msg_10'))
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    showIcon(row) {
      file.selectFileType(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          let type = data.data;
          if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1 || type.indexOf(
            ".gif") != -1) {
            this.showIconList[row] = true;
          } else {
            this.showIconList[row] = false;
          }
        }
      }).catch((response) => {
        console.log(response)
      })
      return this.showIconList[row]
    },
    showName(row) {
      file.selectFileName(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.showNameList[row] = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return this.showNameList[row]
    },
    removeFaultImg(index) {
      this.fileId.splice(index, 1);
      maintenance.saveFileId(this.tableDataInfo.id, this.fileId.join(',')).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.$message({
            message: this.$t('msg_14'),
            type: 'success'
          });
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    upload(file1) {
      if (this.fileId.length == 5) {
        utils.messageAlert(this.$t('msg_11'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      let formData = new FormData();
      formData.append('file', file1.file);
      formData.append('organizationId', this.tableDataInfo.deptId);
      file.upload(formData).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          let fid = data.data
          var fileIdList = '';
          if (this.fileId.length > 0) {
            fileIdList = this.fileId.join(",") + "," + data.data
          } else {
            fileIdList = data.data;
          }
          maintenance.saveFileId(this.tableDataInfo.id, fileIdList).then((response) => {
            const data = response.data;
            let that = this;
            that.showIcon(fid)
            that.showName(fid)
            var timer = setTimeout(
              function () {
                that.fileId.push(fid)
              },
              500
            );
            if (data.code == 1) {
              this.$message({
                message: this.$t('msg_15'),
                type: 'success'
              });
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    listExcel() {
      window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/listExcel?id=' + this.tableDataInfo
        .recordId;
    },
    handleCloseImg() {
      this.dialogImg = false
    },
    handleCloseImg2() {
      this.dialogImg2 = false
    },
    showImg(val) {
      this.imgUrl = val
      this.dialogImg = true
    },
    checkTimebtn(val) {
      let now = new Date()
      if (val == 0) {
        this.Readytime = [this.getBeforeTime(), this.getNowTime()]
      } else if (val == 1) {
        this.changeTime(now.getFullYear() + "-" + this.zero(now.getMonth() + 1) + "-" + this.zero(now.getDate()));
      } else if (val == 2) {
        var date = new Date(now.getFullYear() + "-" + this.zero(now.getMonth() + 1) + "-01");
        this.Readytime1 = date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
        this.changeTime(now.getFullYear() + "-" + this.zero(now.getMonth() + 1) + "-01");
      } else if (val == 3) {
        var date = new Date(now.getFullYear() + "-01-01");
        this.Readytime1 = date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
        this.changeTime(now.getFullYear() + "-01-01");
      }
    },
    changeTime(date) {
      if (this.checkTime == 1) {
        let now = new Date(date)
        let nowTime = now.getTime()
        let day = now.getDay() == 0 ? 7 : now.getDay();
        let oneDayTime = 24 * 60 * 60 * 1000;
        // 本周一时间戳
        let MondayTime = nowTime - (day - 1) * oneDayTime
        // 本周日时间戳
        let SundayTime = nowTime + (7 - day) * oneDayTime
        // 格式化时间
        let monday = new Date(MondayTime)
        let sunday = new Date(SundayTime)
        this.Readytime1 = monday.getFullYear() + "-" + this.zero(monday.getMonth() + 1) + "-" + this.zero(monday.getDate());
        // this.Readytime1_ = sunday.getFullYear() + "-" + this.zero(sunday.getMonth() + 1) + "-" + this.zero(sunday.getDate());
        this.Readytime = [monday.getFullYear() + "-" + this.zero(monday.getMonth() + 1) + "-" + this.zero(monday.getDate()),
          sunday.getFullYear() + "-" + this.zero(sunday.getMonth() + 1) + "-" + this.zero(sunday.getDate())
        ]
      } else if (this.checkTime == 2) {
        var date = new Date(date);
        // //设置月份
        date.setMonth(date.getMonth() + 1);
        //获取本月的最后一天
        var cdate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
        //打印某年某月的最后一天
        this.Readytime = [this.Readytime1, cdate.getFullYear() + "-" + this.zero(cdate.getMonth() + 1) + "-" + this.zero(
          cdate.getDate())]
      } else if (this.checkTime == 3) {
        this.Readytime = [this.Readytime1, this.Readytime1.substring(0, 5) + '12-31']
      }
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },
    spotStatusNumChange(){
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },
    riskExcel() {
      if (this.tableDataInfo.appointMeet == 1) {
        window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel1/' + this.tableDataInfo
          .recordId;
      } else {
        window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel/' + this.tableDataInfo.recordId;
      }

    },
    handleClick0(tab, event) {
      if (tab.name == 'fengx4') {
        let that = this;
        utils.clearTime();
        this.riskRecord();
        utils.timing(function () {
          that.riskRecord()
        }, 30000);
      }
    },
    riskRecord() {
      if (this.tableDataInfo.appointMeet == 1) {
        file.mriskRecord1(this.tableDataInfo.recordId).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.feng4Date1 = data.data[0].date;
            this.feng4Data1 = data.data[0].data;
            this.feng4Date2 = data.data[1].date;
            this.feng4Data2 = data.data[1].data;
            this.feng4Date3 = data.data[2].date;
            this.feng4Data3 = data.data[2].data;
            this.feng4Date4 = data.data[3].date;
            this.feng4Data4 = data.data[3].data;
          }
        }).catch((response) => {
          console.log(response)
        })
      } else {
        file.maintainRecord(this.tableDataInfo.recordId).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.feng4Date = data.data.date;
            this.feng4Data = data.data.data;
          }
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    getLable(index) {
      if (index == 0) {
        return this.$t('label_33') + "(" + 1 + this.$t('label_37') + ")";
      }
      return index + 1 + this.$t('label_37');
    },
    getLable1(index) {
      if (index == 0) {
        return this.$t('label_33');
      }
      return index + this.$t('label_37');
    },
    objectSpanMethod({
                       row,
                       column,
                       rowIndex,
                       columnIndex
                     }) {
      if (rowIndex + 1 == this.feng4Data.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod1({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data1.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data1.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod2({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data2.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data2.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod3({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data3.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data3.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod4({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data4.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data4.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    exportClick() {
      this.$refs.exportBox.setExportExcel();
    },
    export(param) {
      maintenance.exportList(param, this.switched).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTimeExport = data.data;
          for (var i = 0; i < this.tableDataTreeTimeExport.length; i++) {
            this.tableDataTreeTimeExport[i].status = this.spotStatusNumList[this.tableDataTreeTimeExport[i].status].text
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex0(index) {

      if (index == this.feng4Data.length - 1) {
        return this.$t('label_40')
      }
      return index + 1
    },
    getIndex1(index) {
      if (index == this.feng4Data1.length - 1) {
        return this.$t('label_44')
      }
      return index + 1
    },
    getIndex2(index) {
      if (index == this.feng4Data2.length - 1) {
        return this.$t('label_49')
      }
      return index + 1
    },
    getIndex3(index) {
      if (index == this.feng4Data3.length - 1) {
        return this.$t('label_53')
      }
      return index + 1
    },
    getIndex4(index) {
      if (index == this.feng4Data4.length - 1) {
        return this.$t('label_57')
      }
      return index + 1
    },
    selectProp: function (index) {
      // console.log(index)
      this.select = index
    },
    closeImg() {
      this.dialogImg = false;
      this.dialogVideo = false;
    },
    show(id, type) {
      this.img = id;
      if (type == "video") {
        this.dialogVideo = true;
      } else if (type == "photo") {
        this.dialogImg2 = true;
      }

    },
    handler(row) {
      this.fileId = [];
      this.status = row.status;
      this.typeName = '';
      this.deptName = '',
        this.id = row.id,
        maintenance.getResultsById({
          id: row.recordId
        }).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataTree = []
            this.tableDataTree.push(data.data.list);
            this.tableDataInfo.appointMeet = data.data.list.appointMeet;
            this.tableDataInfo.deptId = data.data.list.deptId;
            this.tableDataInfo.id = row.recordId;
            this.fengxianlihuiTime1 = data.data.list.maintainPlanBeginTime;
            this.fengxianlihuiTime2 = data.data.list.maintainPlanEndTime;
            if (data.data.list.fileId != null && data.data.list.fileId != '') {
              this.fileId = data.data.list.fileId.split(",");
            }
            for (var i = data.data.typeName.length - 2; i >= 0; i--) {
              this.typeName += data.data.typeName[i] + ' ';
            }
            // for (var i = data.data.deptName.length - 1; i >= 0; i--) {
            // 	this.deptName += data.data.deptName[i] + ' ';
            // }
            this.deptName = data.data.list.superior
            this.typeName += data.data.typeName[data.data.typeName.length - 1]
            this.tableDataTreeInfo = data.data.list[0]
            this.tableDataTreeInfo = data.data.list
            var checkEndTime = new Date(this.tableDataTreeInfo.maintainEndTime).getTime();
            var checkBeginTime = new Date(this.tableDataTreeInfo.maintainBeginTime).getTime();
            var date = checkEndTime - checkBeginTime; //时间差的毫秒数
            //计算相差分钟数
            var minutes = Math.floor(date / (60 * 1000)) < 10 ? '0' + Math.floor(date / (60 * 1000)) : Math.floor(date / (
              60 * 1000))
            //计算相差秒数
            var leave3 = date % (60 * 1000) //计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3 / 1000) < 10 ? '0' + Math.round(leave3 / 1000) : Math.round(leave3 / 1000)
            this.tableDataTreeInfo.time1 = minutes;
            this.tableDataTreeInfo.time2 = seconds;
            var endTime = new Date(this.tableDataTreeInfo.endTime).getTime();
            var beginTime = new Date(this.tableDataTreeInfo.beginTime).getTime();

            //计划时间
            var date3 = endTime - beginTime;
            //计算相差分钟数
            var minutes2 = Math.floor(date3 / (60 * 1000)) < 10 ? '0' + Math.floor(date3 / (60 * 1000)) : Math.floor(date3 /
              (60 * 1000))
            //计算相差秒数
            var leave5 = date3 % (60 * 1000) //计算分钟数后剩余的毫秒数
            var seconds2 = Math.round(leave5 / 1000) < 10 ? '0' + Math.round(leave5 / 1000) : Math.round(leave5 / 1000)
            this.tableDataTreeInfo.time3 = minutes2;
            this.tableDataTreeInfo.time4 = seconds2;

            if (checkBeginTime > endTime) {
              //实际点检时间 ok
              this.styleObject4.width = '66%'
              this.styleObject5.width = '0%'
              //计划点检时间
              this.styleObject6.width = '0%'
              this.styleObject7.width = '66%'

              this.styleObject1.width = '50%'
              this.styleObject2.width = '50%'
              this.styleObject3.width = '0%'
            } else if (beginTime < checkBeginTime && checkEndTime > endTime) {
              var a = ((checkBeginTime - beginTime) / date3) * 0.8 * 100
              var b = ((endTime - checkEndTime) / date3)
              //实际点检时间
              this.styleObject4.width = (a < 0 ? 0 : a) + '%'
              this.styleObject5.width = '0%'
              //计划点检时间
              this.styleObject6.width = '0%'
              this.styleObject7.width = '20%'

              this.styleObject1.width = (a < 0 ? 0 : a) + '%'
              this.styleObject2.width = (100 - (a < 0 ? 0 : a)) + '%'
              this.styleObject3.width = '0%'
            } else if (beginTime > checkBeginTime && checkEndTime > endTime) {
              //实际点检时间
              this.styleObject4.width = '0%'
              this.styleObject5.width = '0%'
              //计划点检时间
              this.styleObject6.width = '20%'
              this.styleObject7.width = '20%'

              this.styleObject1.width = '0%'
              this.styleObject2.width = '100%'
              this.styleObject3.width = '0%'
            } else if (beginTime > checkBeginTime && checkEndTime < endTime) {
              var b = ((endTime - checkEndTime) / date3) * 0.8 * 100
              //实际点检时间
              this.styleObject4.width = '0%'
              this.styleObject5.width = b + '%'
              //计划点检时间
              this.styleObject6.width = '20%'
              this.styleObject7.width = '0%'

              this.styleObject1.width = '0%'
              this.styleObject2.width = (100 - b) + '%'
              this.styleObject3.width = b + '%'
            } else {
              var a = ((checkBeginTime - beginTime) / date3) * 100
              var b = ((endTime - checkEndTime) / date3) * 100
              this.styleObject4.width = (a < 0 ? 0 : a) + '%'
              this.styleObject5.width = (b < 0 ? 0 : b) + '%'
              //计划点检时间
              this.styleObject6.width = '0%'
              this.styleObject7.width = '0%'

              this.styleObject1.width = (a < 0 ? 0 : a) + '%'
              this.styleObject2.width = (100 - (a < 0 ? 0 : a) - (b < 0 ? 0 : b)) + '%'
              this.styleObject3.width = (b < 0 ? 0 : b) + '%'
            }

          }
        }).catch((response) => {
          console.log(response)
        })
      maintenance.selectByIdPart({
        id: row.recordId
      }).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataBeijian = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      maintenance.selectByIdRisk({
        id: row.id
      }).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          for (var i = 0; i < this.fengXianConfrim.length; i++) {
            if (data.data[this.fengXianConfrim[i].key] != null && data.data[this.fengXianConfrim[i].key] != '') {
              var check = [];
              for (var key in data.data[this.fengXianConfrim[i].key]) {
                check.push({
                  mes: key
                })
                if (data.data[this.fengXianConfrim[i].key][key][data.data[this.fengXianConfrim[i].key][key].length - 1].abnormalFlag ==
                  1) {
                  this.checkComfrim.push(key)
                }
              }
              this.fengXianConfrim[i].check = check;
            }
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleClose() {
      this.dialogSpotResult = false;
      this.dialogSpotRemark = false;
      this.mainEditTree = 'project';
      utils.clearTime();
    },
    results() {
      // if (this.status == 2 || this.status == 4) {
      if (this.tableDataTree == null || this.tableDataTree == '') {
        return;
      }
      this.dialogSpotResult = true
      // } else {
      // 	utils.messageAlert("请选择保养状态是正常保养或逾期保养的数据", this.$t('label_358'), this.$t('label_100'));
      // }
    },
    saveRemark() {
      if (Object.keys(this.tableDataInfo).length > 0) {
        this.dialogSpotRemark = true;
        this.newType.id = this.tableDataInfo.recordId;
        this.newType.remark = this.tableDataInfo.remark;
      } else {
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
      }
    },
    check(checkStatus) {
      this.checkUser = checkStatus;
      // for (var i = 0; i < this.spotStatusNumList.length; i++) {
      // 	this.spotStatusNumList[i].check = true;
      // }
      this.checkStatus = checkStatus,
        this.checkFlag = true;
      this.checkTime = checkStatus;
      this.checkTimebtn(checkStatus);
      this.spotStatusNumList[0].check = false;
      this.spotStatusNumList[1].check = false;
      this.spotStatusNumList[2].check = true;
      this.spotStatusNumList[3].check = false;
      this.spotStatusNumList[4].check = true;
      this.search({
        pageNum: 1,
        pageSize: 9999,
      });
    },
    checkOff() {
      this.checkFlag = false;
      this.checkStatus = 0;
      this.checkUser = 0;
      this.checkTime = 0;
      this.checkTimebtn(0);
      this.spotStatusNumList[0].check = true;
      this.spotStatusNumList[1].check = true;
      this.spotStatusNumList[2].check = true;
      this.spotStatusNumList[3].check = true;
      this.spotStatusNumList[4].check = true;
      this.search({
        pageNum: 1,
        pageSize: 10,
      });
    },
    checkOne() {
      if (this.tableDataInfo != null && Object.keys(this.tableDataInfo).length > 0) {
        this.$confirm(this.$t('label_62'), this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          maintenance.check([this.tableDataInfo], this.checkUser).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              for (let i = 0; i < this.tableDataTreeTime.length; i++) {
                if (this.tableDataTreeTime[i].id == this.tableDataInfo.id) {
                  this.tableDataTreeTime.splice(i, 1);
                }
              }
              this.spotStatusNumList[this.tableDataInfo.status].num--;
              this.tableDataTree = '';
              this.tableDataInfo = {};
              this.$message({
                message: this.$t('msg_16'),
                type: 'success'
              });
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {
        });
      } else {
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
      }
    },
    checkBack(checkUser) {
      if (this.tableDataInfo != null && Object.keys(this.tableDataInfo).length > 0) {
        if (checkUser == 3 && this.tableDataInfo.checkStatus != 4) {
          utils.messageAlert(this.$t('msg_33'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (checkUser == 2 && this.tableDataInfo.checkStatus != 3) {
          utils.messageAlert(this.$t('msg_35'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        if (checkUser == 1 && this.tableDataInfo.checkStatus != 2) {
          utils.messageAlert(this.$t('msg_34'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        this.$confirm(this.$t('msg_36'), this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          maintenance.checkBack([this.tableDataInfo], checkUser).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_20'),
                type: 'success'
              });
              this.search({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
              });
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {
        });
      } else {
        this.$message({
          message: this.$t('msg_1'),
          type: 'warning'
        });
      }
    },
    checkAll() {
      this.$confirm(this.$t('msg_37'), this.$t('label_358'), {
        confirmButtonText: this.$t('label_100'),
        cancelButtonText: this.$t('btn_1'),
        type: 'warning'
      }).then(() => {
        maintenance.check(this.tableDataTreeTime, this.checkUser).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataTreeTime = [];
            this.spotStatusNumList[0].num = 0;
            this.spotStatusNumList[1].num = 0;
            this.spotStatusNumList[2].num = 0;
            this.spotStatusNumList[3].num = 0;
            this.spotStatusNumList[4].num = 0;
            this.tableDataTree = '';
            this.tableDataInfo = {};
            this.$message({
              message: this.$t('msg_16'),
              type: 'success'
            });
          }
        }).catch((response) => {
          console.log(response)
        })
      }).catch(() => {
      });
    },
    newTypeSave() {
      this.saveLoading = true;
      maintenance.checkSaveRemark(this.newType).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogSpotRemark = false;
          this.search({
            pageNum: 1,
            pageSize: this.pageSize,
          });
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    handleCurrentChangeAll(info) {
    },
    handleCurrentChangeDevice(info) {
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    tableDataTreeInfoEdit() {
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        this.dialogDeviceSpot = true;
        this.tableDataTreeEdit = this.tableDataTreeInfo
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    handleCurrentChangeTreeTime(info) {
      this.tableDataInfo = info;
    },
    handleClickTree(tab, event) {
      this.getTreeMes = '1';
      this.deviceDetailMes = {};
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },
    handleClickSpot(tab, event) {
      // console.log(tab, event);
    },
    handleClickDevice(tab, event) {
      // console.log(tab, event);
    },
    weekChange(date) {
      let now = new Date(date)
      let nowTime = now.getTime()
      let day = now.getDay() == 0 ? 7 : now.getDay();
      let oneDayTime = 24 * 60 * 60 * 1000;
      // 本周一时间戳
      let MondayTime = nowTime - (day - 1) * oneDayTime
      // 本周日时间戳
      let SundayTime = nowTime + (7 - day) * oneDayTime
      // 格式化时间
      let monday = new Date(MondayTime)
      let sunday = new Date(SundayTime)
      this.Readytime1 = monday.getFullYear() + "-" + this.zero(monday.getMonth() + 1) + "-" + this.zero(monday.getDate());
      this.Readytime1_ = sunday.getFullYear() + "-" + this.zero(sunday.getMonth() + 1) + "-" + this.zero(sunday.getDate());
    },
    search(param) {
      this.tableDataTreeTime = [];
      this.tableDataInfo = {

      };
      let status = [];
      for (var i = 0; i < this.spotStatusNumList.length; i++) {
        if (this.spotStatusNumList[i].check == true) {
          status.push(i)
        }
      }

      // let begin;
      // let end;
      // if(!this.checkFlag){
      // 	begin = this.Readytime[0];
      // 	end = this.Readytime[1];
      // }else if(this.checkUser==1){
      // 	begin = this.Readytime1;
      // 	end = this.Readytime1_;
      // }else if(this.checkUser==2){
      // 	begin = this.Readytime2+'-01';
      // 	let endDay = new Date(begin)
      // 	endDay.setMonth(endDay.getMonth() + 1)
      // 	endDay.setDate(0)
      // 	end = endDay.getFullYear() + "-" + this.zero(endDay.getMonth() + 1) + "-" + this.zero(endDay.getDate());
      // }else{
      // 	begin = this.Readytime3+'-01-01';
      // 	end = this.Readytime3+'-12-31';
      // }

      var dataParam = {
        beginTime: this.Readytime[0] + " 00:00:00",
        endTime: this.Readytime[1] + " 23:59:59",
        maintainName: this.maintainName,
        code: this.code,
        status: status,
        type: this.deviceDetailMes.type,
        id: this.deviceDetailMes.id,
        checkStatus: this.checkStatus,
      }
      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      console.log(newParam)
      this.searchPage(newParam);
      this.searchStauts(newParam);
      this.export(dataParam);
    },
    searchPage(param) {
      maintenance.getPage(param, this.switched).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTime = data.data.records
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchStauts(param) {
      maintenance.getStatus(param, this.switched).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.spotStatusNumList[0].num = data.data.status0
          this.spotStatusNumList[1].num = data.data.status1
          this.spotStatusNumList[2].num = data.data.status2
          this.spotStatusNumList[3].num = data.data.status3
          this.spotStatusNumList[4].num = data.data.status4
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getDeviceMes(data) {
      if (data.name == this.$t('label_272')) {
        this.deviceDetailMes = {};
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      } else {
        this.deviceDetailMes = data;
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      }
    },
    getRiskList() {
      file.getByDictIdALL({dictId: 7, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.fengXianConfrim = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getRiskList().then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.fengXianConfrim = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    // riskExcel(){
    // 	window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel3?time=' + this.Readytime[0]
    // 		.substring(0, 7) +  "&id=" + this.id;
    // },
    getNowTime() {
      let zeroTime = new Date();
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
      return now;
    },
    getBeforeTime() {
      var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
      let zeroTime = new Date(time);
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
      return now;
    },
    calcDay(date, i) {
      let d = new Date(date).getTime() + 1000 * 60 * 60 * 24 * i;
      date = new Date(d);
      return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
    },
    zero(i) {
      return i > 9 ? i : '0' + i;
    },
    showBtn() {
      this.qrCodeShow = !this.qrCodeShow;
      if (this.qrCodeShow) {
        this.width = "0px";
      } else {
        this.width = "340px";
      }
    },
  },
  created() {
    this.checkTimebtn(0);
    // this.Readytime = [this.getBeforeTime(), this.getNowTime()];
    // this.weekChange(this.calcDay(this.Readytime[1], -7));
    // let now = new Date();
    // now.setMonth(now.getMonth() - 1);
    // this.Readytime2 = now.getFullYear() + "-" + this.zero(now.getMonth() + 1);
    // this.Readytime3 = now.getFullYear() - 1 + "";
    this.getRiskList();
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #ffffff;
}

.cb .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

.treeMes .spotMesBox #fengx4 {
  width: 160px;
}

.timeRadio .el-radio-button__inner {
  padding: 12px 12px;
}

.fileName {
  font-size: 10px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
   cursor : pointer; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80px
}

.photoNewdiv {
  width: 80px;
  height: 80px;
  margin-left: 30px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
}

.imgstyle {
  width: 60px;
  height: 50px;
}

.imgdelect {
  position: absolute;
  top: 0px;
  right: 0px;
  color: #000000;
  cursor: pointer;
}

.right-showbtn-qrcode-background {
  /* position: absolute; */
  width: 10px;
  height: 80px;
  background-color: #9c9c9c;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: auto;
}

.right-showbtn {
  width: 10px;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/maintainResumePage.vue